const toUsdCurrency = (number) => {
  if (number % 1 === 0) return fraction.format(number)
  else return formatter.format(number)
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
})

const fraction = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
})

const toLocaleCurrency = ({
  locale,
  currency,
  number,
  currencyPrices,
  discountPercentage,
}) => {
  const localeFormatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  })

  const localeFraction = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
  })

  // Replace price with any matching currency price
  const currencyPriceMatch = (currencyPrices || []).find(
    (p) => p.price && p.currency === currency
  )
  const currencyPrice = currencyPriceMatch
    ? currencyPriceMatch.price * (1 - (discountPercentage || 0) / 100)
    : number
  if (number % 1 === 0) return localeFraction.format(currencyPrice)
  else return localeFormatter.format(currencyPrice)
}

export { toUsdCurrency, toLocaleCurrency }
